import { TextField, TextFieldProps } from "@mui/material";
import { IGWidget, addClass } from "../GWidget";
import { IFormFieldProps, useValidator } from "../form/Validators";
import { useEffect } from "react";

export interface IGTextFieldProps extends IGWidget, IFormFieldProps<string>, Omit<TextFieldProps,"value"> {
    value?:string;
    onEnter?:(val:string) => void
}

export default function GTextField(props:IGTextFieldProps) {
    const {onChange,helperText,floatLabel,controlName,onEnter,...textProps} = props
    const {value, setValue, hint, control, hasError, validate} = useValidator<string>(props)
    
    const _onChange = (e:any) => {
        control?.setDirty(true)
        setValue(e.target.value) 
        props.onChange?.(e)
    }
    const onKeyDown = (e:any) => {
        if (e.key=="Enter") onEnter?.(value||"")
    }
    useEffect(() => {
        const input = (props.inputRef as any)?.current
        if (input && input.value) validate(input.value)
    },[props.inputRef])

    return <TextField className={addClass("", props)} onChange={_onChange} onKeyDown={onKeyDown}
        label={floatLabel} helperText={props.helperText||hint} error={hasError} 
        size="small" variant="outlined" {...textProps}/>
}
